var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-icon"},[_c('i',{class:( _obj = {}, _obj[_vm.icon] = true, _obj.loading = _vm.isLoading, _obj ),on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }